"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateFile = exports.getUploadPayload = exports.getUploadFileFormat = exports.getProcessPayload = exports.getFoldersAndFiles = exports.getFiles = exports.getCancelPayload = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _docsHttpClient = require("@adsk/docs-http-client");
var CommonUtil = _interopRequireWildcard(require("./commons"));
var _consts = require("./consts");
var FileUtil = _interopRequireWildcard(require("./files"));
var _revitReader = _interopRequireDefault(require("./revitReader"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var validFilename = function validFilename(fileName) {
  /* eslint-disable */
  // 1. name is too_long,
  // 2. name with special char
  // 3. preserved name
  // 4. name end with special character.
  if (CommonUtil.isStringTooLong(fileName, 255)) {
    return _consts.UPLOAD_ERRORS.FILE_NAME_TOO_LONG;
  } else if (CommonUtil.hasSpecialCharacter(fileName)) {
    return _consts.UPLOAD_ERRORS.FILE_NAME_INVALID_CHARS;
  } else if (CommonUtil.isReservedName(fileName)) {
    return _consts.UPLOAD_ERRORS.FILE_NAME_RESERVED;
  } else if (CommonUtil.isEndWithPeriod(fileName)) {
    return _consts.UPLOAD_ERRORS.FILE_NAME_END_PERIOD;
  }
  /* eslint-enable */
  return null;
};
var isFileSupported = function isFileSupported(extension) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$linked = _ref.linked,
    linked = _ref$linked === void 0 ? false : _ref$linked,
    _ref$sheets = _ref.sheets,
    sheets = _ref$sheets === void 0 ? false : _ref$sheets;
  if (linked) return sheets === true ? _consts.UPLOAD_LINKED_EXTENSION.includes(extension) : !_consts.EXECUTABLE_FILE_TYPES.includes(extension);
  if (sheets) return _consts.UPLOAD_SHEETS_EXTENSION.includes(extension);
  return !_consts.EXECUTABLE_FILE_TYPES.includes(extension);
};
var validateRvtFile = function validateRvtFile(file) {
  return new Promise(function (resolve) {
    return _revitReader["default"].getRvtInfo(file, function (info) {
      if (['invalidFileSize', 'notRvt', 'readFileError', 'unsupportedBrowser'].includes(info.ErrorMessage)) {
        resolve({
          code: _consts.UPLOAD_ERRORS.INVALID_RVT_FILE,
          message: info.ErrorMessage
        });
      } else {
        resolve({});
      }
    });
  });
};
var validateFile = exports.validateFile = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(file, options) {
    var fileType, nameValidate, isValid;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof window === 'undefined' || !window.navigator)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", {
            code: _consts.UPLOAD_ERRORS.BROWSER_ONLY
          });
        case 2:
          if (!(!file || !file.name)) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", {
            code: _consts.UPLOAD_ERRORS.INVALID_FILE
          });
        case 4:
          if (!(file.size > _consts.AWS_S3_FILE_SIZE_LIMIT)) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", {
            code: _consts.UPLOAD_ERRORS.FILESIZE_EXCEEDED
          });
        case 6:
          fileType = FileUtil.getFileExtension(file.name);
          nameValidate = validFilename(file.name);
          if (!nameValidate) {
            _context.next = 10;
            break;
          }
          return _context.abrupt("return", {
            code: nameValidate
          });
        case 10:
          if (!(fileType === 'mat')) {
            _context.next = 15;
            break;
          }
          _context.next = 13;
          return FileUtil.isValidMatFile(file);
        case 13:
          isValid = _context.sent;
          return _context.abrupt("return", {
            code: isValid ? '' : _consts.UPLOAD_ERRORS.INVALID_MAT_FILE
          });
        case 15:
          if (isFileSupported(fileType, options)) {
            _context.next = 17;
            break;
          }
          return _context.abrupt("return", {
            code: _consts.UPLOAD_ERRORS.INVALID_FILE_TYPE
          });
        case 17:
          if (!(fileType === 'rvt')) {
            _context.next = 21;
            break;
          }
          _context.next = 20;
          return validateRvtFile(file);
        case 20:
          return _context.abrupt("return", _context.sent);
        case 21:
          return _context.abrupt("return", {});
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function validateFile(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

// -------------------------------------------------------------------------------------- //
// Upload command related
// -------------------------------------------------------------------------------------- //
var genCommandPayload = function genCommandPayload(type, data) {
  var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '2.1.0';
  return {
    jsonapi: {
      version: '1.0'
    },
    data: {
      type: 'commands',
      attributes: {
        extension: {
          version: version,
          type: type,
          data: data
        }
      }
    }
  };
};
var getUploadPayload = exports.getUploadPayload = function getUploadPayload(folderUrn, files) {
  return genCommandPayload('commands:autodesk.bim360:files.upload', {
    translate: true,
    files: files.map(function (_ref3) {
      var name = _ref3.name,
        size = _ref3.size,
        storageUrn = _ref3.storageUrn,
        _ref3$versionExtensio = _ref3.versionExtensionProperties,
        versionExtensionProperties = _ref3$versionExtensio === void 0 ? [] : _ref3$versionExtensio;
      return {
        parentFolderUrn: folderUrn,
        versionName: name,
        versionDisplayName: name,
        versionStorage: storageUrn,
        versionStorageType: 'OSS_PROVIDED',
        versionFileSize: size,
        versionExtensionProperties: versionExtensionProperties,
        tempUrn: (0, _docsHttpClient.uuidV4)()
      };
    })
  });
};
var getCancelPayload = exports.getCancelPayload = function getCancelPayload(urns) {
  return genCommandPayload('commands:autodesk.bim360:files.cancel', {
    versions: urns.map(function (versionedUrn) {
      return {
        versionedUrn: versionedUrn
      };
    })
  });
};
var getProcessPayload = exports.getProcessPayload = function getProcessPayload(cmdData) {
  return genCommandPayload('commands:autodesk.bim360:files.process', cmdData);
};
var getEntry = function getEntry(entity) {
  return 'getAsEntry' in entity ? entity.getAsEntry() : 'webkitGetAsEntry' in entity ? entity.webkitGetAsEntry() : entity;
};
var getFoldersAndFiles = exports.getFoldersAndFiles = function getFoldersAndFiles(entities) {
  var folders = [];
  var files = [];
  (0, _toConsumableArray2["default"])(entities).forEach(function (entity) {
    var entry = getEntry(entity);
    if (entry.isDirectory) {
      folders.push(entity);
    }
    if (entry.isFile) {
      files.push(entity.getAsFile());
    }
  });
  return [folders, files];
};

/**
 * Two kinds of entities types:
 * 1. pure files from input[type="file"], [File] type
 * 2. files and folders from drag and drop, [DataTransferItem] type
 * Client can distinguish folder and file, has the ability to upload folders with DataTransferItem object
 */
var getFiles = exports.getFiles = function getFiles(entities) {
  if (entities instanceof DataTransferItemList) {
    var _getFoldersAndFiles = getFoldersAndFiles(entities),
      _getFoldersAndFiles2 = (0, _slicedToArray2["default"])(_getFoldersAndFiles, 2),
      files = _getFoldersAndFiles2[1];
    return files;
  }
  return entities;
};
var getFileRvtInfo = function getFileRvtInfo(file) {
  return new Promise(function (resolve) {
    _revitReader["default"].getRvtInfo(file, function (info) {
      resolve(info);
    });
  });
};
var getUploadFileFormat = exports.getUploadFileFormat = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(file) {
    var fileType, rvtInfo, rvtVersion;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          fileType = FileUtil.getFileExtension(file.name);
          if (!(fileType === 'rvt')) {
            _context2.next = 7;
            break;
          }
          _context2.next = 4;
          return getFileRvtInfo(file);
        case 4:
          rvtInfo = _context2.sent;
          rvtVersion = rvtInfo.RvtVersion;
          return _context2.abrupt("return", {
            version: String(rvtVersion)
          });
        case 7:
          return _context2.abrupt("return", undefined);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getUploadFileFormat(_x3) {
    return _ref4.apply(this, arguments);
  };
}();